module.exports = __webpack_public_path__ + "img/flower-field.38bc4dc1.webp";